import tableReport from './widgets/tableReport';

export default [tableReport];
